/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates what type of alignment to use for the column options icon.
 */
export var ColumnOptionsIconAlignment = /*@__PURE__*/ (function (ColumnOptionsIconAlignment) {
    /**
     * Use the default alignment.
     */
    ColumnOptionsIconAlignment[ColumnOptionsIconAlignment["Unset"] = 0] = "Unset";
    /**
     * The icon is not aligned so it will appear alongside the header text.
     */
    ColumnOptionsIconAlignment[ColumnOptionsIconAlignment["None"] = 1] = "None";
    /**
     * The icon is aligned with the edge of the column but opposite the alignment of the header text.
     */
    ColumnOptionsIconAlignment[ColumnOptionsIconAlignment["Opposite"] = 2] = "Opposite";
    return ColumnOptionsIconAlignment;
})({});
/**
 * @hidden
 */
export var ColumnOptionsIconAlignment_$type = /*@__PURE__*/ markEnum('ColumnOptionsIconAlignment', 'Unset,0|None,1|Opposite,2');
//# sourceMappingURL=ColumnOptionsIconAlignment.js.map
